const config = {
  PROD: {
    STRIPE_PUBLIC_KEY:
      'pk_live_51RFNn7A9kyakv2Pq2maOAF2uAwDNDYnGjJukf7iw3lxqS5D052UIGJkm1Zx3fSgykp7LdHU34Y8CXcFtm6JmyxcE00xbSkGhjw',
    GITHUB_APPLICATION_URL: `https://github.com/apps/hikaflow`,
    BE_URL: 'https://api.hikaflow.com',
    REFERRAL_LINK: 'https://app.hikaflow.com/ref/',
  },
  DEV: {
    STRIPE_PUBLIC_KEY:
      'pk_test_51Ooj13E9g5lMqEuarYDdI92qB6JthN2lgeWYmkLDtX6mjdHDlee8Kd2dh8R79J9Xyt533XkSAuJIZFAeNIXuGqtz00bmnkO5Ma',
    GITHUB_APPLICATION_URL: `https://github.com/apps/hikaflow-test-app`,
    BE_URL: 'http://localhost:3000',
    REFERRAL_LINK: 'http://localhost:3001/ref/',
  },
};

export default config;

export const getEnvironmentConfig = (KEY) => {
  if (!KEY) {
    return window.location.hostname === 'localhost' ? config.DEV : config.PROD;
  }
  let environment =
    window.location.hostname === 'localhost' ? config.DEV : config.PROD;

  return environment[KEY];
};
